import { ChakraProvider } from '@chakra-ui/react'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { useEffect } from 'react'
import { BrowserRouter, Navigate, Route, Routes, useParams } from 'react-router-dom'

import { useHasRole, WEBSITE_URL } from './helpers'
import { AbraMidiaEditPage } from './pages/Dashboard/AbraMidia/AbraMidiaEditPage'
import { AbraMidiaNewPage } from './pages/Dashboard/AbraMidia/AbraMidiaNewPage'
import { AbraMidiaPage } from './pages/Dashboard/AbraMidia/AbraMidiaPage'
import { AbraMidiaViewHomePage } from './pages/Dashboard/AbraMidia/AbraMidiaViewHomePage'
import { AbraMidiaViewPage } from './pages/Dashboard/AbraMidia/AbraMidiaViewPage'
import AceleraMagentaCompletePage from './pages/Dashboard/AceleraMagenta/AceleraMagentaCompletePage'
import AceleraMagentaNewPage from './pages/Dashboard/AceleraMagenta/AceleraMagentaNewPage'
import AceleraMagentaPage from './pages/Dashboard/AceleraMagenta/AceleraMagentaPage'
import AceleraMagentaStepPage from './pages/Dashboard/AceleraMagenta/AceleraMagentaStepPage'
import AdmissionFormPage from './pages/Dashboard/Admission/AdmissionFormPage'
import AdmissionsKanbanPage from './pages/Dashboard/Admissions/AdmissionsKanbanPage'
import ArtworkEvaluationPage from './pages/Dashboard/ArtworkEvaluation/ArtworkEvaluationPage'
import BannersPage from './pages/Dashboard/Banners/BannersPage'
import BlackListPage from './pages/Dashboard/BlackList/BlackListPage'
import BlogPostPage from './pages/Dashboard/BlogPosts/BlogPostPage'
import BrilhaMagentaCompletePage from './pages/Dashboard/BrilhaMagenta/BrilhaMagentaCompletePage'
import BrilhaMagentaEmployeeNotePage from './pages/Dashboard/BrilhaMagenta/BrilhaMagentaEmployeeNotePage'
import BrilhaMagentaNewPage from './pages/Dashboard/BrilhaMagenta/BrilhaMagentaNewPage'
import BrilhaMagentaPage from './pages/Dashboard/BrilhaMagenta/BrilhaMagentaPage'
import BrilhaMagentaStepPage from './pages/Dashboard/BrilhaMagenta/BrilhaMagentaStepPage'
import CommercialConsultantsPage from './pages/Dashboard/CommercialConsultants/CommercialConsultantsPage'
import ConexaoMagentaCompletePage from './pages/Dashboard/ConexaoMagenta/ConexaoMagentaCompletePage'
import ConexaoMagentaNewPage from './pages/Dashboard/ConexaoMagenta/ConexaoMagentaNewPage'
import ConexaoMagentaPage from './pages/Dashboard/ConexaoMagenta/ConexaoMagentaPage'
import ConexaoMagentaQuestionsPage from './pages/Dashboard/ConexaoMagenta/ConexaoMagentaQuestionsPage'
import ContactSnippetPage from './pages/Dashboard/ContactSnippet/ContactSnippetPage'
import ContestDetailPage from './pages/Dashboard/Contests/ContestDetailPage'
import ContestsPage from './pages/Dashboard/Contests/ContestsPage'
import ContestsApplicationsPage from './pages/Dashboard/ContestsApplications/ContestsApplicationsPage'
import ContestsLabelsPage from './pages/Dashboard/ContestsLabels/ContestsLabelsPage'
import CoursesListPage from './pages/Dashboard/Courses/CoursesPage'
import DashboardPage from './pages/Dashboard/DashboardPage'
import DutyPlannerPage from './pages/Dashboard/DutyPlanner/DutyPlannerPage'
import EmployeesPage from './pages/Dashboard/Employees/EmployeesPage'
import EntregaDeTrabalhosPage from './pages/Dashboard/EntregaTrabalho/EntregaDeTrabalhoPage'
import EntregaDeTrabalhoSubmitPage from './pages/Dashboard/EntregaTrabalho/EntregaDeTrabalhoSubmitPage'
import EventCommissionsPage from './pages/Dashboard/EventCommissions/EventCommissionsPage'
import EventCouponsPage from './pages/Dashboard/EventCoupons/EventCouponsPage'
import EventAuctionScreenPage from './pages/Dashboard/Events/AuctionScreen/EventAuctionScreenPage'
import EventAdminPage from './pages/Dashboard/Events/EventAdminPage'
import EventDetailPage from './pages/Dashboard/Events/EventDetailPage'
import EventEstablishmentSalesPage from './pages/Dashboard/Events/EventEstablishmentSalesPage'
import EventOrdersPage from './pages/Dashboard/Events/EventOrdersPage'
import EventPage from './pages/Dashboard/Events/EventPage'
import EventTabsPage from './pages/Dashboard/Events/EventTabsPage'
import EventTransactionsPage from './pages/Dashboard/Events/EventTransactionsPage'
import EventSurveyResultsPage from './pages/Dashboard/Events/survey/EventSurveyResultsPage'
import ExperienceFeedbackCompletePage from './pages/Dashboard/ExperienceFeedback/ExperienceFeedbackCompletePage'
import ExperienceFeedbackNewPage from './pages/Dashboard/ExperienceFeedback/ExperienceFeedbackNewPage'
import ExperienceFeedbackPage from './pages/Dashboard/ExperienceFeedback/ExperienceFeedbackPage'
import ExperienceFeedbackStepPage from './pages/Dashboard/ExperienceFeedback/ExperienceFeedbackStepPage'
import ExperimentalClassesPage from './pages/Dashboard/ExperimentalClasses/ExperimentalClassesPage'
import FinanceUrlRedirectorsPage from './pages/Dashboard/FinanceUrlRedirectors/FinanceUrlRedirectorsPage'
import FinancialIndicatorsPage from './pages/Dashboard/FinancialIndicators/FinancialIndicatorsPage'
import FormLeadsPage from './pages/Dashboard/FormLeads/FormLeadsPage'
import GemsPage from './pages/Dashboard/Gems/GemsPage'
import HomePage from './pages/Dashboard/Home/HomePage'
import JobApplicationPage from './pages/Dashboard/JobApplications/JobApplicationPage'
import JobPositionPage from './pages/Dashboard/JobPositions/JobPositionPage'
import JobRequisitionsPage from './pages/Dashboard/JobRequisitions/JobRequisitionsPage'
import MachinesPage from './pages/Dashboard/Machines/MachinesPage'
import NotificationsPage from './pages/Dashboard/Notifications/NotificationsPage'
import PersonnelMovementRequestsCompletePage from './pages/Dashboard/PersonnelMovementRequests/PersonnelMovementRequestsCompletePage'
import PersonnelMovementRequestsNewPage from './pages/Dashboard/PersonnelMovementRequests/PersonnelMovementRequestsNewPage'
import PersonnelMovementRequestsPage from './pages/Dashboard/PersonnelMovementRequests/PersonnelMovementRequestsPage'
import PersonnelMovementRequestsStepPage from './pages/Dashboard/PersonnelMovementRequests/PersonnelMovementRequestsStepPage'
import RefundsCompletePage from './pages/Dashboard/Refunds/RefundsCompletePage'
import RefundsNewPage from './pages/Dashboard/Refunds/RefundsNewPage'
import RefundsPage from './pages/Dashboard/Refunds/RefundsPage'
import RefundsStepPage from './pages/Dashboard/Refunds/RefundsStepPage'
import RequestsPage from './pages/Dashboard/Requests/RequestsPage'
import SalesReceiptsPage from './pages/Dashboard/SalesReceipts/SalesReceiptsPage'
import SalesReceiptSubmitPage from './pages/Dashboard/SalesReceipts/SalesReceiptSubmitPage'
import ScheduleClassesPage from './pages/Dashboard/ScheduleClasses/ScheduleClassesPage'
import SectorsPage from './pages/Dashboard/Sectors/SectorsPage'
import StudyCreditKanbanPage from './pages/Dashboard/StudyCreditRequests/StudyCreditKanbanPage'
import StudyCreditSubmitPage from './pages/Dashboard/StudyCreditRequests/StudyCreditSubmitPage'
import SupportPage from './pages/Dashboard/Support/SupportPage'
import SupportViewPage from './pages/Dashboard/Support/SupportViewPage'
import SurveyReportPage from './pages/Dashboard/Surveys/SurveyReportPage'
import TeacherPage from './pages/Dashboard/Teachers/TeacherPage'
import TestimonialsPage from './pages/Dashboard/Testimonials/TestimonialsPage'
import TestimonialVideosPage from './pages/Dashboard/TestimonialVideos/TestimonialVideosPage'
import TestimonialVideoSubmitPage from './pages/Dashboard/TestimonialVideos/TestimonialVideoSubmitPage'
import UrlShortenerPage from './pages/Dashboard/UrlShortener'
import UsersPage from './pages/Dashboard/Users/UsersPage'
import UsersGroupsPage from './pages/Dashboard/UsersGroups/UserGroupsPage'
import VideoQuizPage from './pages/Dashboard/VideoQuiz/VideoQuizPage'
import LoginPage from './pages/Login/LoginPage'
import NotFoundPage from './pages/NotFound/NotFoundPage'
import { PreviewEntregaDeTrabalho } from './pages/PreviewEntregaDeTrabalho/PreviewEntregaDeTrabalho'
import { VideoQuiz } from './pages/VideoQuiz/VideoQuiz'
import { VideoQuizForm } from './pages/VideoQuiz/VideoQuizForm'
import theme from './theme'

interface IProtectedRouteProps {
  element: JSX.Element
  allowedRoles?: string[]
}

function ProtectedRoute({ element, allowedRoles = [] }: IProtectedRouteProps) {
  const hasSystemRole = useHasRole()

  if (allowedRoles.length > 0 && !hasSystemRole(allowedRoles)) {
    // Anonymous visitor (e.g. deep link from an automation e-mail): go to login
    // keeping the intended URL so LoginPage can redirect back after authenticating.
    if (!localStorage.getItem('token')) {
      sessionStorage.setItem('redirect_after_login', window.location.pathname + window.location.search)
      return <Navigate to="/login" replace />
    }

    return <Navigate to="/404" replace />
  }

  return element
}

function ContestSiteRedirect() {
  const { slug } = useParams<{ slug: string }>()

  useEffect(() => {
    if (!slug) return
    window.location.replace(`${WEBSITE_URL}/concurso/${slug}`)
  }, [slug])

  return null
}

export default function Routers() {
  return (
    <GoogleOAuthProvider clientId="1077749715116-1ipu66jcgofdc5qd6krlpscdu56t298d.apps.googleusercontent.com">
      <ChakraProvider theme={theme}>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/entrega-de-trabalho/preview/:id" element={<PreviewEntregaDeTrabalho />} />
            <Route path="/video-quiz" element={<VideoQuizForm />} />
            <Route path="/video-quiz/:uuid" element={<VideoQuiz />} />
            <Route path="/abra-midia/visualizar" element={<AbraMidiaViewHomePage />} />
            <Route path="/abra-midia/visualizar/:code" element={<AbraMidiaViewPage />} />
            <Route path="/" element={<DashboardPage />}>
              <Route index element={<Navigate to="/home" replace />} />
              <Route path="/home" element={<HomePage />} />

              <Route path="/users" element={<ProtectedRoute element={<UsersPage />} allowedRoles={['view_users']} />} />
              <Route
                path="/users-groups"
                element={<ProtectedRoute element={<UsersGroupsPage />} allowedRoles={['view_users']} />}
              />
              <Route
                path="/sectors"
                element={<ProtectedRoute element={<SectorsPage />} allowedRoles={['view_sectors']} />}
              />
              <Route
                path="/form-leads"
                element={<ProtectedRoute element={<FormLeadsPage />} allowedRoles={['view_leads']} />}
              />
              <Route
                path="/aulas-experimentais"
                element={
                  <ProtectedRoute element={<ExperimentalClassesPage />} allowedRoles={['view_experimental_class']} />
                }
              />
              <Route
                path="/black-list"
                element={<ProtectedRoute element={<BlackListPage />} allowedRoles={['view_blacklist']} />}
              />
              <Route
                path="/website-banners"
                element={<ProtectedRoute element={<BannersPage />} allowedRoles={['view_banners']} />}
              />
              <Route
                path="/blog-posts"
                element={<ProtectedRoute element={<BlogPostPage />} allowedRoles={['view_posts']} />}
              />
              <Route
                path="/courses"
                element={<ProtectedRoute element={<CoursesListPage />} allowedRoles={['view_courses']} />}
              />
              <Route
                path="/teachers"
                element={<ProtectedRoute element={<TeacherPage />} allowedRoles={['view_teachers']} />}
              />
              <Route
                path="/cronograma-de-turmas"
                element={<ProtectedRoute element={<ScheduleClassesPage />} allowedRoles={['view_class_schedules']} />}
              />
              <Route
                path="/events"
                element={<ProtectedRoute element={<EventPage />} allowedRoles={['view_events']} />}
              />
              <Route
                path="/events/:slug"
                element={<ProtectedRoute element={<EventDetailPage />} allowedRoles={['view_events']} />}
              />
              <Route
                path="/events/:slug/orders"
                element={<ProtectedRoute element={<EventOrdersPage />} allowedRoles={['view_events']} />}
              />
              <Route
                path="/events/:slug/establishments"
                element={<ProtectedRoute element={<EventEstablishmentSalesPage />} allowedRoles={['view_events']} />}
              />
              <Route
                path="/events/:slug/transactions"
                element={<ProtectedRoute element={<EventTransactionsPage />} allowedRoles={['view_events']} />}
              />
              <Route
                path="/events/:slug/tabs"
                element={<ProtectedRoute element={<EventTabsPage />} allowedRoles={['view_events']} />}
              />
              <Route
                path="/events/:slug/admin"
                element={<ProtectedRoute element={<EventAdminPage />} allowedRoles={['view_events']} />}
              />
              <Route
                path="/events/:slug/pesquisa"
                element={<ProtectedRoute element={<EventSurveyResultsPage />} allowedRoles={['view_event_survey']} />}
              />
              <Route
                path="/events/:slug/auction-screen"
                element={<ProtectedRoute element={<EventAuctionScreenPage />} allowedRoles={['view_events']} />}
              />
              <Route
                path="/testimonials"
                element={<ProtectedRoute element={<TestimonialsPage />} allowedRoles={['view_students']} />}
              />
              <Route
                path="/entrega-de-trabalhos"
                element={<ProtectedRoute element={<EntregaDeTrabalhosPage />} allowedRoles={['view_assignments']} />}
              />
              <Route path="/entrega-de-trabalho/enviar" element={<EntregaDeTrabalhoSubmitPage />} />
              <Route
                path="/job-positions"
                element={<ProtectedRoute element={<JobPositionPage />} allowedRoles={['view_jobs']} />}
              />
              <Route
                path="/admissoes"
                element={<ProtectedRoute element={<AdmissionsKanbanPage />} allowedRoles={['view_admissions']} />}
              />
              <Route
                path="/colaboradores"
                element={<ProtectedRoute element={<EmployeesPage />} allowedRoles={['view_employees']} />}
              />
              <Route
                path="/vagas-de-emprego"
                element={
                  <ProtectedRoute
                    element={<JobRequisitionsPage />}
                    allowedRoles={['view_job_requisitions', 'sign_job_requisitions']}
                  />
                }
              />
              <Route
                path="/job-applications"
                element={<ProtectedRoute element={<JobApplicationPage />} allowedRoles={['view_talents']} />}
              />

              <Route
                path="/video-quizes"
                element={<ProtectedRoute element={<VideoQuizPage />} allowedRoles={['view_video_quizzes']} />}
              />

              <Route
                path="/pesquisas-de-satisfacao"
                element={<ProtectedRoute element={<SurveyReportPage />} allowedRoles={['view_surveys']} />}
              />

              <Route path="/abra-midia" element={<AbraMidiaPage />} />
              <Route path="/abra-midia/new" element={<AbraMidiaNewPage />} />
              <Route path="/abra-midia/:id" element={<AbraMidiaEditPage />} />

              <Route
                path="/acelera-magenta"
                element={
                  <ProtectedRoute
                    element={<AceleraMagentaPage />}
                    allowedRoles={['view_evaluations', 'view_sector_evaluations']}
                  />
                }
              />
              <Route
                path="/conexao-magenta"
                element={
                  <ProtectedRoute
                    element={<ConexaoMagentaPage />}
                    allowedRoles={['view_evaluations_conexao', 'view_sector_evaluations_conexao']}
                  />
                }
              />
              <Route
                path="/brilha-magenta"
                element={
                  <ProtectedRoute
                    element={<BrilhaMagentaPage />}
                    allowedRoles={['view_evaluations_brilha', 'view_sector_evaluations_brilha']}
                  />
                }
              />
              <Route
                path="/solicitacoes"
                element={<ProtectedRoute element={<RequestsPage />} allowedRoles={['view_requests']} />}
              />

              <Route path="/acelera-magenta/new" element={<AceleraMagentaNewPage />} />
              <Route path="/acelera-magenta/complete" element={<AceleraMagentaCompletePage />} />
              <Route path="/acelera-magenta/:id" element={<AceleraMagentaStepPage />} />
              <Route path="/conexao-magenta/new" element={<ConexaoMagentaNewPage />} />
              <Route path="/conexao-magenta/complete" element={<ConexaoMagentaCompletePage />} />
              <Route path="/conexao-magenta/:id" element={<ConexaoMagentaQuestionsPage />} />
              <Route path="/brilha-magenta/new" element={<BrilhaMagentaNewPage />} />
              <Route path="/brilha-magenta/complete" element={<BrilhaMagentaCompletePage />} />
              <Route path="/brilha-magenta/nota-colaborador/:uuid" element={<BrilhaMagentaEmployeeNotePage />} />
              <Route path="/brilha-magenta/:id" element={<BrilhaMagentaStepPage />} />

              <Route
                path="/consultores-comerciais"
                element={<ProtectedRoute element={<CommercialConsultantsPage />} allowedRoles={['view_consultants']} />}
              />
              <Route
                path="/feriados-e-plantoes"
                element={<ProtectedRoute element={<DutyPlannerPage />} allowedRoles={['view_holidays']} />}
              />

              <Route
                path="/url-shortener/commercial"
                element={
                  <ProtectedRoute element={<UrlShortenerPage used_by="commercial" />} allowedRoles={['view_utms']} />
                }
              />
              <Route
                path="/url-shortener/marketing"
                element={
                  <ProtectedRoute
                    element={<UrlShortenerPage used_by="marketing" />}
                    allowedRoles={['view_marketing_urls']}
                  />
                }
              />
              <Route
                path="/url-redirector/finances"
                element={
                  <ProtectedRoute element={<FinanceUrlRedirectorsPage />} allowedRoles={['view_finance_redirectors']} />
                }
              />

              <Route
                path="/experience-feedback"
                element={
                  <ProtectedRoute
                    element={<ExperienceFeedbackPage />}
                    allowedRoles={['view_experience_feedbacks', 'view_sector_experience_feedbacks']}
                  />
                }
              />
              <Route path="/experience-feedback/new" element={<ExperienceFeedbackNewPage />} />
              <Route path="/experience-feedback/complete" element={<ExperienceFeedbackCompletePage />} />
              <Route path="/experience-feedback/:id" element={<ExperienceFeedbackStepPage />} />

              <Route
                path="/personnel-movement"
                element={
                  <ProtectedRoute
                    element={<PersonnelMovementRequestsPage />}
                    allowedRoles={['view_personnel_movement_requests', 'view_sector_personnel_movement_requests']}
                  />
                }
              />
              <Route path="/personnel-movement/new" element={<PersonnelMovementRequestsNewPage />} />
              <Route path="/personnel-movement/complete" element={<PersonnelMovementRequestsCompletePage />} />
              <Route path="/personnel-movement/:id" element={<PersonnelMovementRequestsStepPage />} />

              <Route
                path="/refunds"
                element={
                  <ProtectedRoute element={<RefundsPage />} allowedRoles={['view_refunds', 'view_sector_refunds']} />
                }
              />
              <Route path="/refunds/new" element={<RefundsNewPage />} />
              <Route path="/refunds/complete" element={<RefundsCompletePage />} />
              <Route path="/refunds/:id" element={<RefundsStepPage />} />

              <Route
                path="/comprovantes-de-vendas"
                element={<ProtectedRoute element={<SalesReceiptsPage />} allowedRoles={['view_sales_receipts']} />}
              />
              <Route path="/comprovantes-de-vendas/enviar" element={<SalesReceiptSubmitPage />} />

              <Route path="/aproveitamento-de-estudos/new" element={<StudyCreditSubmitPage />} />

              <Route path="/admissao" element={<AdmissionFormPage />} />
              <Route path="/admissao/continuar/:token" element={<AdmissionFormPage />} />
              <Route
                path="/aproveitamento-de-estudos"
                element={
                  <ProtectedRoute element={<StudyCreditKanbanPage />} allowedRoles={['view_study_credit_requests']} />
                }
              />

              <Route
                path="/videos-de-depoimento"
                element={
                  <ProtectedRoute element={<TestimonialVideosPage />} allowedRoles={['view_testimonial_videos']} />
                }
              />
              <Route path="/videos-de-depoimento/enviar" element={<TestimonialVideoSubmitPage />} />

              <Route
                path="/financial-indicators"
                element={
                  <ProtectedRoute element={<FinancialIndicatorsPage />} allowedRoles={['edit_financial_indicators']} />
                }
              />

              <Route
                path="/contests"
                element={<ProtectedRoute element={<ContestsPage />} allowedRoles={['view_contests']} />}
              />
              <Route
                path="/contests/applications"
                element={
                  <ProtectedRoute
                    element={<ContestsApplicationsPage />}
                    allowedRoles={['view_contests_applications']}
                  />
                }
              />
              <Route
                path="/contests/artwork-evaluation"
                element={
                  <ProtectedRoute
                    element={<ArtworkEvaluationPage />}
                    allowedRoles={['evaluate_contest_artworks', 'view_contest_votes']}
                  />
                }
              />
              <Route
                path="/contests/artwork-evaluation/:slug"
                element={
                  <ProtectedRoute
                    element={<ArtworkEvaluationPage />}
                    allowedRoles={['evaluate_contest_artworks', 'view_contest_votes']}
                  />
                }
              />
              <Route
                path="/contests/:slug"
                element={<ProtectedRoute element={<ContestDetailPage />} allowedRoles={['view_contests']} />}
              />

              <Route path="/concurso/:slug" element={<ContestSiteRedirect />} />
              <Route path="/concurso/:slug/inscricao" element={<ContestSiteRedirect />} />
              <Route path="/concurso/:slug/envio" element={<ContestSiteRedirect />} />
              <Route
                path="/contests/artwork-labels/:slug"
                element={
                  <ProtectedRoute element={<ContestsLabelsPage />} allowedRoles={['view_contests_applications']} />
                }
              />

              <Route path="/gems" element={<GemsPage />} />

              <Route
                path="/contact-code-generator"
                element={<ProtectedRoute element={<ContactSnippetPage />} allowedRoles={['view_contact_snippets']} />}
              />

              <Route path="/support" element={<SupportPage />} />
              <Route path="/support/:id" element={<SupportViewPage />} />

              <Route path="/notificacoes" element={<NotificationsPage />} />

              <Route
                path="/event-coupons"
                element={<ProtectedRoute element={<EventCouponsPage />} allowedRoles={['view_coupons']} />}
              />
              <Route
                path="/comissao-de-eventos"
                element={
                  <ProtectedRoute element={<EventCommissionsPage />} allowedRoles={['view_event_commissions']} />
                }
              />
              <Route
                path="/machines"
                element={<ProtectedRoute element={<MachinesPage />} allowedRoles={['manage_machines']} />}
              />
            </Route>
            <Route path="/404" element={<NotFoundPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </BrowserRouter>
      </ChakraProvider>
    </GoogleOAuthProvider>
  )
}
